import css from "./Table.module.css";

import { RootContent, Table as TypeTable } from "mdast";
import { ReactNode } from "react";
import { GameVer } from "~/util/Lang";
import { MDDat } from "~/util/MarkdownRenderer";

export function Table(props: {
  table: TypeTable;
  dat: MDDat;
  gver: GameVer;
  renderChildren: (
    children: RootContent[],
    dat: MDDat,
    gver: GameVer
  ) => ReactNode;
}) {
  const { dat, renderChildren, table, gver } = props;
  return (
    <div style={{ overflowX: "auto" }}>
      <table className={css.root}>
        <thead>
          <tr>
            {table.children[0].children.map((cell, j) => (
              <th key={j}>{renderChildren(cell.children, dat, gver)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {table.children.slice(1).map((row, i) => (
            <tr key={i}>
              {row.children.map((cell, j) => (
                <td key={j}>{renderChildren(cell.children, dat, gver)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
